import React, { useState, useEffect, useMemo } from 'react'
import {
    Grid,
    Box, Stack, Typography, Button,
    InputLabel,
    TextField,
    IconButton,
    Tooltip
} from '@mui/material'
import _ from 'lodash'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { topicsSelector, saveTopicData, saveStandardTopicData } from "../../../store/slices/topics";
import { useSelector, useDispatch } from 'react-redux'
import { TopicChip as Chip } from './topicChip';
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import AppConfig from '../../../appConfig';
import { companiesSelector } from '../../../store/slices/company';
import { convertArrayToDictionary } from '../../../common/utils';
import moment from 'moment';


const Topics = ({ title, companyId, onToogleTopicsModal, isGenerateTopics, topics, height, isEdit, onSetEdit,
    outPutDnd, jsonObjectComponent, jsonObj, onToogleHistoryModal, isShowDBTopics = true, showData, showHeader = true,
    topicKey, lastModified, isInitialTopics, businessType, isGenerated,companyCompanyId }) => {

    const { promptText, companyTopics, standardTopics } = useSelector(topicsSelector)
const {companies}=useSelector(companiesSelector)
    const dispatch = useDispatch();

    const [addedValues, setAddedValues] = useState([]);

    const [addItem, setAddItem] = useState([]);
    const [showExistingTopics, setShowExistingTopics] = useState(true);
    const [editItem, setEditItem] = useState(null);
    const isDevMode = true;// useMemo(() => _.includes(['local', 'dev'], AppConfig.appMode), [AppConfig.appMode])
    // useEffect(() => {
    //     setShowExistingTopics(!isInitialTopics)
    // }, [isInitialTopics])
    const uuidv4 = () => {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
    const combindMultipleObjects = (data) => {
        let res = {};
        _.map(data, it => {
            if (it) {
                const splitArr = _.split(it, ',');
                const arr = _.filter(splitArr, it => {
                    return it !== '\n}'
                })
                const val = _.join(arr, ',') + (arr.length !== splitArr.length ? '\n}' : '')
                let jObject = {};
                try {
                    jObject = JSON.parse(val);
                } catch (e) {
                    jObject = {} // error in the above string (in this case, yes)!
                }
                _.map(Object.keys(jObject), item => {
                    res[item] = _.uniq(_.filter(_.concat(res[item], jObject[item]), obj => { return obj }));
                })
            }

        })
        return res;
    }
    const appendTopicsAndSubTopics = (dbArray, topicsArr) => {
        const sequence = _.maxBy(dbArray, 'sequence')?.sequence + 1;
        const dbRows = _.groupBy(_.cloneDeep(dbArray), 'name');

        const latestTopics = _.map(Object.keys(topicsArr), (item, i) => {
            return {
                name: item,

                sequence: sequence + i,
                data: _.map(topicsArr?.[item], (it, j) => { return { name: it, insideDB: false, sequence: j + 1, } }),
                insideDB: false,
            }
        })
        dbArray = _.concat(dbArray, latestTopics);

        const fetchRows = _.groupBy(_.filter(_.cloneDeep(dbArray), { insideDB: false }), 'name');

        dbArray = _.map(_.groupBy(dbArray, 'name'), (items, key) => {
            const isAdded = !dbRows[key];
            const isDeleted = _.filter(items, { insideDB: true })?.length > 0 && !fetchRows[key];
            const type = isAdded ? 1 : isDeleted ? 2 : 0;
            const subTopics = _.flatMapDeep(_.map(items, 'data'));
            const dbTopicId = dbRows[key]?.[0]?.topicId
            const topicId = isAdded ? uuidv4() : dbTopicId;
            const sequence = isAdded ? items[0]?.sequence : dbRows[key]?.[0]?.sequence;

            return {
                color: type == 1 ? 'green' : (type == 2 ? 'red' : 'auto'),
                type: type,
                name: key,
                sequence: sequence,
                topicId: dbTopicId ?? null,
                parentTopicId: null,
                id: topicId,
                parentId: null,
                companyId: companyId,
                data: _.map(_.uniqBy(subTopics, 'name'), it => {

                    const dbSubCategories = _.map(dbRows[key]?.[0]?.data, 'name') ?? [];
                    const subCategories = _.map(fetchRows[key]?.[0]?.data, 'name') ?? [];

                    const isAdded = !_.includes(dbSubCategories, it.name);
                    const isDeleted = _.includes(dbSubCategories, it.name) && !_.includes(subCategories, it.name);
                    const type = isAdded ? 1 : isDeleted ? 2 : 0;
                    const dbId = _.find(dbRows[key]?.[0]?.data, { name: it.name })?.topicId
                    const id = isAdded ? uuidv4() : dbId;
                    return {
                        ...it,
                        color: type == 1 ? 'green' : (type == 2 ? 'red' : 'auto'),
                        type: type,
                        companyId: companyId,
                        topicId: dbId ?? null,
                        parentTopicId: dbTopicId ?? null,
                        id: id,
                        parentId: topicId,
                    }
                })
            }
        });
        return dbArray;
    }
    const appendTopicsAndSubTopics1 = (dbArray, topicsArr) => {
        const sequence = _.maxBy(dbArray, 'sequence')?.sequence + 1;
        const dbRows = _.groupBy(_.cloneDeep(dbArray), 'name');
        let latestTopics = _.map(topicsArr ? Object.keys(topicsArr) : [], (item, i) => {
            const values = topicsArr?.[item][0];
            const keys = values ? Object.keys(values) : []
            return {
                name: item,

                sequence: sequence + i,
                data: _.map(keys, (it, j) => {
                    return {
                        name: it,
                        positiveContext: values[it]?.PositiveAspect,
                        negativeContext: values[it]?.NegativeAspect,
                        summary: '',
                        insideDB: false, sequence: j + 1,
                    }
                }),
                insideDB: false,
            }
        })
        if (isGenerated || _.size(dbRows) <= 0) {
            dbArray = _.concat(dbArray, latestTopics);
            const fetchRows = _.groupBy(_.filter(_.cloneDeep(dbArray), { insideDB: false }), 'name');

            dbArray = _.map(_.groupBy(dbArray, 'name'), (items, key) => {
                const isAdded = !dbRows[key];
                const isDeleted = _.filter(items, { insideDB: true })?.length > 0 && !fetchRows[key];
                const type = isAdded ? 1 : isDeleted ? 2 : 0;
                const subTopics = _.flatMapDeep(_.map(items, 'data'));
                const dbTopicId = dbRows[key]?.[0]?.topicId
                const topicId = isAdded ? uuidv4() : dbTopicId;
                const sequence = isAdded ? items[0]?.sequence : dbRows[key]?.[0]?.sequence;
    
                return {
                    color: type == 1 ? 'green' : (type == 2 ? 'red' : 'auto'),
                    type: type,
                    name: key,
                    sequence: sequence,
                    topicId: dbTopicId ?? null,
                    parentTopicId: null,
                    id: topicId,
                    parentId: null,
                    companyId: companyId,
                    data: _.map(_.uniqBy(subTopics, 'name'), it => {
    
                        const dbSubCategories = _.map(dbRows[key]?.[0]?.data, 'name') ?? [];
                        const subCategories = _.map(fetchRows[key]?.[0]?.data, 'name') ?? [];
    
                        const isAdded = !_.includes(dbSubCategories, it.name);
                        const isDeleted = _.includes(dbSubCategories, it.name) && !_.includes(subCategories, it.name);
                        const type = isAdded ? 1 : isDeleted ? 2 : 0;
                        const dbId = _.find(dbRows[key]?.[0]?.data, { name: it.name })?.topicId
                        const id = isAdded ? uuidv4() : dbId;
                        return {
                            ...it,
                            color: type == 1 ? 'green' : (type == 2 ? 'red' : 'auto'),
                            type: type,
                            companyId: companyId,
                            topicId: dbId ?? null,
                            parentTopicId: dbTopicId ?? null,
                            id: id,
                            parentId: topicId,
                        }
                    })
                }
            });
        }

        return dbArray;
    }
    const bindTopics = () => {
        let topicArray = isShowDBTopics ? _.orderBy(isInitialTopics ? standardTopics : companyTopics ?? [], ['sequence']) : [];
        let groupedData = _.groupBy(topicArray, 'parentTopicId');
        let parents = _.filter(topicArray, { parentTopicId: null });
        let dbArray = showExistingTopics ? _.orderBy(_.map(parents, item => {
            return {
                name: item.name,
                topicId: item.topicId,
                id: item.topicId,
                parentTopicId: null,
                parentId: null,
                type: 0,
                sequence: item.sequence,
                data: _.map(groupedData[item.topicId], it => {
                    return {
                        name: it.name,
                        summary: it.description,
                        positiveContext: it.positiveContext,
                        negativeContext: it.negativeContext,
                        insideDB: true,
                        topicId: it.topicId,
                        parentTopicId: item.topicId,
                        id: it.topicId,
                        parentId: item.topicId,
                        sequence: it.sequence,
                        type: 0,
                    }
                }),
                insideDB: true,
            }
        }), ['sequence']) : [];
        const topicsArr = combindMultipleObjects(topics ? topics[topicKey]?.output : [])
        if (_.size(topicsArr) > 0) {
            dbArray = isInitialTopics ? appendTopicsAndSubTopics1(dbArray, topicsArr) : appendTopicsAndSubTopics(dbArray, topicsArr)
        }
        if (_.size(jsonObj) > 0) {
            let obj = {};
            try {
                obj = JSON.parse(jsonObj);
            } catch (e) {
                obj = {} // error in the above string (in this case, yes)!
            }
            dbArray = isInitialTopics ? appendTopicsAndSubTopics1(dbArray, obj) : appendTopicsAndSubTopics(dbArray, obj)
        }
        let arrList = [];
        _.map(dbArray, item => {
            arrList = _.concat(arrList, [item]);
            arrList = _.concat(arrList, item.data);

            return arrList;
        });

        return arrList;
    }

    const finalData = (data) => {
        let topicArray = _.orderBy(data ?? [], ['sequence']);
        let groupedData = _.groupBy(topicArray, 'parentId');

        let parents = _.filter(topicArray, { parentId: null });
        let list = _.orderBy(_.map(parents, item => {
            return {
                ...item,
                data: _.map(groupedData[item.id], it => {
                    return it;
                }),
            }
        }), ['sequence']);
        return list;
    }
    const addList = (parentId, value) => {
        let addedValue = _.cloneDeep(addedValues);
        if (value) {

            const obj = _.find(addedValue, { id: parentId });
            // if (obj?.data && !_.includes(_.map(obj?.data, 'id'), addItem.id)) {
            let addObj = {
                type: 1,
                name: value,
                sequence: obj?.data?.length + 1,
                topicId: null,
                parentTopicId: obj?.topicId ? obj?.topicId : null,
                id: uuidv4(),
                parentId: parentId ? parentId : null,
                companyId: companyId,
                color: 'green',
            }
            if (parentId) {
                obj.data.push(addObj);
            }
            else {
                addObj.data = [];
            }

            addedValue.push(addObj)
            // }
        }
        return addedValue;
    }
    const editList = (id, value) => {
        let addedValue = _.cloneDeep(addedValues);
        if (value && id) {

            let editObj = _.find(addedValue, { id: id });
            if (value !== editObj.name) {
                editObj.name = value;
                editObj.type = editObj.type === 0 ? 3 : editObj.type;
                addedValue = _.filter(addedValue, it => { return it.id !== id });

                addedValue.push(editObj);
            }

        }
        return addedValue;
    }
    const companyDic=useMemo(()=>convertArrayToDictionary(companies,'companyId'),[companies])
const selectedCompany=useMemo(()=>companyDic[companyCompanyId]??{},[companyDic,companyCompanyId])
    const topicsData = React.useMemo(() => bindTopics(), [companyTopics, standardTopics, topics?.[topicKey], jsonObj, showExistingTopics, topicKey]);
    const data = React.useMemo(() => finalData(addedValues), [addedValues]);
    const handleExport = () => {
        const excelData=_.flatten(_.map(data,item=>{
            const childArr= _.map(item?.data,(it,index)=>{
                return ({
                    category:item?.name,
                    topic:it?.name,
                    positiveContext:it?.positiveContext??" ",
                    negativeContext:it?.negativeContext??" ",
                    color:it.color
                })
            })
            return childArr
        }))

     
        const fileName = `${businessType}-StandardTopics- ${moment().format("YYYYMMDD")}-${Math.floor(Math.random() * 1000000)}`;
        const workbook = new ExcelJS.Workbook();
    
        const columns = [
            {
                key:'category',
                width:30
            },
          {
            key: "topic",
            width: 30,
          },
          {
            key: "positiveContext",
            width: 60,
          },
          {
            key: "negativeContext",
            width: 60,
          },
        ];
    
        const worksheet = workbook.addWorksheet("Standard Topics");
        let headers = _.map(columns, it => _.startCase(it.key));
        worksheet.getRow(1).values = headers;
        worksheet.columns = columns;
        excelData?.forEach(function (item, index) {
           const row=  worksheet.addRow(item)
           row.eachCell({ includeEmpty: false }, function (cell) {
            worksheet.getCell(cell.address).border = {
              top: { style: "thin", color: { argb: "5c9cd4" } },
              left: { style: "thin", color: { argb: "5c9cd4" } },
              bottom: { style: "thin", color: { argb: "5c9cd4" } },
              right: { style: "thin", color: { argb: "5c9cd4" } },
            };
            worksheet.getCell(cell.address).alignment={
                wrapText: true
              }
          });
          if(index%2!==0){
            row.eachCell({ includeEmpty: false }, function (cell) {
                worksheet.getCell(cell.address).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb:item?.color==='green'?'91FFB1':item?.color==='red'?"FF9191":"FFFFFF" },
                  
                }
            })
          }
          if (index % 2 === 0) {
    
            row.eachCell({ includeEmpty: false }, function (cell) {
              worksheet.getCell(cell.address).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb:item?.color==='green'?'91FFB1':item?.color==='red'?"FF9191":"DEEAF6" },
                
              };
              worksheet.getCell(cell.address).alignment={
                wrapText: true
              }
            });
          }
            })
     worksheet.getRow(1).eachCell({ includeEmpty: false }, function (cell) {
                worksheet.getCell(cell.address).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "8DB4E2" },
                };
                worksheet.getCell(cell.address).font = {
                  color: { argb: "0000000" },
                  family: 2,
                  size: 12,
                };
                worksheet.getCell(cell.address).border = {
                  top: { style: "thin", color: { argb: "5c9cd4" } },
                  left: { style: "thin", color: { argb: "5c9cd4" } },
                  bottom: { style: "thin", color: { argb: "5c9cd4" } },
                  right: { style: "thin", color: { argb: "5c9cd4" } },
                };
                worksheet.getCell(cell.address).alignment = {
                  horizontal: "center",
                  
                };
              });
        workbook.xlsx.writeBuffer().then(function (data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, `${fileName}.xlsx`);
        });
      };
    useEffect(() => {
        if (companyId) {
            setAddedValues(topicsData);
        }
    }, [topicsData,companyId]);

    // useEffect(() => {
    //     if (addItem.value) {
    //         let finalData = _.cloneDeep(addedValues);
    //         setAddedValues(getTopicsData(finalData));
    //         setAddItem({ id: null, parentId: null, value: null })
    //     }
    // }, [addItem.value])
    const saveTopics = (e) => {
        if (isInitialTopics) {
            onSaveStandardTopics(e)
        }
        else {
            onSaveTopics(e);
        }
    }
    const onSaveTopics = (e) => {
        let obj = { AddTopics: [], AddSubTopics: [], Modify: [], Delete: [], CompanyId: companyId }
        let cloneAddedValues = _.cloneDeep(addedValues);
        let savedData = _.filter(cloneAddedValues, it => { return it.type == 1 });
        let modifiedData = _.filter(cloneAddedValues, it => { return it.type == 3 });

        let topicIds = _.map(cloneAddedValues, 'topicId');

        const deletedData = _.filter(_.cloneDeep(topicsData), item => { return (item.type == 0 || item.type == 2) && !_.includes(topicIds, item.topicId) });

        const newTopics = _.filter(savedData, { topicId: null, parentTopicId: null });
        const groupedByNewTopics = _.groupBy(newTopics, 'parentId');

        obj.AddTopics = _.map(_.filter(newTopics, { parentId: null }), item => {
            return {
                Topic: item.name,
                SubTopics: _.map(groupedByNewTopics[item.id], 'name')
            }
        });
        obj.AddSubTopics = _.map(_.filter(savedData, it => { return !it.topicId && it.parentTopicId }), item => {
            return {
                Id: item.parentTopicId,
                Name: item.name
            }
        });
        obj.Modify = _.map(_.filter(modifiedData, it => { return it.topicId }), item => {
            return {
                Id: item.topicId,
                Name: item.name
            }
        });
        obj.Delete = _.map(deletedData, 'topicId');

        if ((savedData?.length > 0 || deletedData?.length > 0 || modifiedData?.length > 0) && companyId) {
            // dispatch(saveTopicData(obj, companyId));
        }

    };

    const onSaveStandardTopics = (e) => {
        let obj = { AddTopics: [], AddSubTopics: [], Modify: [], Delete: [], CompanyType: businessType }
        let cloneAddedValues = _.cloneDeep(addedValues);
        let savedData = _.filter(cloneAddedValues, it => { return it.type == 1 });
        let modifiedData = _.filter(cloneAddedValues, it => { return it.type == 3 });

        let topicIds = _.map(cloneAddedValues, 'topicId');

        const deletedData = _.filter(_.cloneDeep(topicsData), item => { return (item.type == 0 || item.type == 2) && !_.includes(topicIds, item.topicId) });

        const newTopics = _.filter(savedData, { topicId: null, parentTopicId: null });
        const groupedByNewTopics = _.groupBy(newTopics, 'parentId');

        obj.AddTopics = _.map(_.filter(newTopics, { parentId: null }), item => {

            return {
                Topic: item.name,
                SubTopics: _.map(groupedByNewTopics[item.id], it => {
                    return {
                        Name: it.name, Description: it.summary,
                        positiveContext: it.positiveContext,
                        negativeContext: it.negativeContext,
                    }
                })
            }
        });
        obj.AddSubTopics = _.map(_.filter(savedData, it => { return !it.topicId && it.parentTopicId }), item => {
            return {
                Id: item.parentTopicId,
                Name: item.name,
                Description: item.summary,
                positiveContext: item.positiveContext,
                negativeContext: item.negativeContext,
            }
        });
        obj.Modify = _.map(_.filter(modifiedData, it => { return it.topicId }), item => {
            return {
                Id: item.topicId,
                Name: item.name,
                Description: item.summary,
                positiveContext: it.positiveContext,
                negativeContext: it.negativeContext,
            }
        });
        obj.Delete = _.map(deletedData, 'topicId');

        if ((savedData?.length > 0 || deletedData?.length > 0 || modifiedData?.length > 0) && businessType) {
            dispatch(saveStandardTopicData(obj, businessType));
        }

    };
    const onRestTopics = (e) => {
        let cloneAddedValues = _.cloneDeep(topicsData);
        setAddedValues(cloneAddedValues);

    };
    const handleClick = (id) => {
        setEditItem(id)
    };
    const onAddItem = (id, parentId) => {
        let addItems = _.cloneDeep(addItem);
        if (!_.includes(parentId)) {
            addItems.push(parentId)
            setAddItem(addItems);
        }
    };
    const onChangeAddItem = (value, parentId) => {
        if (value) {
            setAddedValues(addList(parentId, value));
            let addItems = _.filter(_.cloneDeep(addItem), it => { return it !== parentId });
            setAddItem(addItems)
        }

    };
    const onChangeEditItem = (value, id) => {
        if (value) {
            setAddedValues(editList(id, value));
            setEditItem(null)
        }

    };
    const onEmptyClick = () => {
    };
    const handleDelete = (id, isParent) => {
        const values = _.filter(_.cloneDeep(addedValues), it => { return it.id !== id && (!isParent || it.parentId !== id) });
        setAddedValues(values);

    };
    const addHandleDelete = (id) => {
        const values = _.filter(_.cloneDeep(addItem), it => { return it !== id });
        setAddItem(values);
        // setAddItem({ id: null, parentId: null });
    };
    const AddNewSubTopic = (i, parentId, isParent) => {
        return (<Chip key={i + "_child"}
            label={
                <TextField
                    autoFocus
                    inputProps={{ sx: { fontSize: ' 0.8125rem', height: '0.5em', my: 1, pt: 1, px: '5px', border: 'none', position: 'unset', '&:focus': { background: 'unset' } } }}
                    variant="standard"
                    InputProps={{
                        disableUnderline: true,
                    }}
                    size=""
                    sx={{ width: '100px', border: 'none', '& :focus': { background: 'unset' } }}
                    onBlur={(e) => onChangeAddItem(e.target.value, parentId)}
                ></TextField>
            }
            variant="outlined"
            sx={{ ml: 0, marginRight: 1, width: '100px', mt: (isParent ? 3 : 1.25), fontSize: ' 0.8125rem' }}
            // onClick={handleClick}
            onDelete={(e) => addHandleDelete(parentId)}
            size={isParent ? 'small' : 'small'}
        />)
    }
    const isDisabled = !(((isInitialTopics || showExistingTopics) && _.filter(addedValues, it => { return it.type > 0 })?.length > 0) || _.size(addedValues) !== _.size(topicsData))
    return (
        <Grid container size={'small'}>
            <Box sx={{ width: '100%', overflowWrap: 'break-word' }}>
                {showHeader &&
                    <>
                        <Stack direction="row" sx={{ pb: 0.5 }} spacing={1} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography variant="subtitle1">{title + ':'}</Typography>
                            {outPutDnd &&
                                <Box>
                                    {outPutDnd()}
                                </Box>
                            }
                            <Stack alignItems={'center'}>
                                <Box sx={{ textAlign: 'right' }}>
                                    {jsonObjectComponent &&
                                        jsonObjectComponent
                                    }
                                    {!isEdit &&
                                        <Box sx={{ width: '80px' }}></Box>
                                    }
                                    {isEdit && isDevMode &&
                                        <>
                                         <Button
                                                width={'80px'}
                                                size="small"
                                                color="primary"
                                                variant="contained"
                                                onClick={handleExport}
                                                sx={{mr:2, textTransform: 'none'}}
                                            >
                                                Export
                                            </Button>
                                            <Button
                                                width={'80px'}
                                                disabled={isDisabled}
                                                color="primary"
                                                variant="contained"
                                                onClick={(e) => { onRestTopics() }}
                                                sx={{ textTransform: 'none' }}
                                                size="small"
                                            >
                                                Reset
                                            </Button>
                                            <Button
                                                disabled={isDisabled}
                                                // disabled={true}
                                                color="primary"
                                                variant="contained"
                                                sx={{ ml: 2, textTransform: 'none' }}
                                                // sx={{ mt: (theme) => theme.spacing(2) }}
                                                onClick={(e) => { saveTopics() }}
                                                size="small"
                                            >
                                                Save
                                            </Button>
                                        </>
                                    }
                                    {isEdit && isGenerateTopics &&
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            sx={{ ml: 2 }}
                                            // sx={{ mt: (theme) => theme.spacing(2) }}
                                            onClick={(e) => { onSetEdit(false) }}
                                        >
                                            Cancel
                                        </Button>

                                    }
                                    {onToogleHistoryModal && isDevMode &&
                                        <Button
                                            // disabled={checked.length === 0}
                                            color="primary"
                                            variant="dashed"
                                            sx={{ ml: 2 }}
                                            onClick={() => onToogleHistoryModal(true)}
                                        >
                                            History
                                        </Button>
                                    }
                                </Box>
                            </Stack>

                        </Stack>
                        <hr style={{ marginTop: 0, }} />
                    </>
                }
                {/* {showHeader && <hr style={{ marginTop: 5, }} />} */}
                {showData &&
                    <Box>
                        {lastModified}
                        <Box sx={{ overflow: "auto", height: height }}>
                            {_.map(data, (item, index) => {
                                return (
                                    <Box key={index + "_parent"} sx={{
                                        mt: theme => index > 0 ? theme.spacing(1.5) : theme.spacing(0.5),
                                        // color: item.color ? item.color : 'auto'
                                    }}>
                                        <Stack direction="row" spacing={1} sx={{ display: 'flex', mb: 1 }}>
                                            <Chip
                                                label={
                                                    editItem !== item.id ? <InputLabel sx={{ color: item.color ? item.color : 'auto' }}><Typography variant="subtitle1">{item.name}</Typography></InputLabel>
                                                        : <TextField
                                                            autoFocus
                                                            inputProps={{ sx: { fontSize: ' 0.8125rem', height: '0.5em', my: 1, border: 'none', position: 'unset', '&:focus': { background: 'unset' } } }}
                                                            variant="standard"
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                            defaultValue={item.name}
                                                            size=""
                                                            sx={{ width: '100px', border: 'none', '& :focus': { background: 'unset' } }}
                                                            onBlur={(e) => editItem !== item.id ? onEmptyClick : onChangeEditItem(e.target.value, item.id)}
                                                        ></TextField>}
                                                sx={{ color: item.color ? item.color : 'auto' }}
                                                onClick={() => isEdit ? handleClick(item.id) : onEmptyClick}
                                                onDelete={isEdit ? (e) => handleDelete(item.id, true) : null}
                                                size='small'
                                            >
                                            </Chip>
                                        </Stack>
                                        <Stack rowGap={0.2} direction="row" flexWrap={'wrap'} sx={{ lineHeight: '40px', pl: 3 }}>
                                            {item.data.map((a, i) =>

                                                <Tooltip key={'topic' + (index + i)}
                                                    title={(a.positiveContext ? ('Postive Context: ' + a.positiveContext + '\n') : '') + (a.negativeContext ? ('Negative Context: ' + a.negativeContext) : '')}
                                                >
                                                    <span>
                                                        <Chip key={i + "_child"}
                                                            label={editItem !== a.id ? a.name : <TextField
                                                                autoFocus
                                                                inputProps={{ sx: { fontSize: ' 0.8125rem', height: '0.5em', mt: 1, pt: 1, border: 'none', position: 'unset', '&:focus': { background: 'unset' } } }}
                                                                variant="standard"
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                                defaultValue={a.name}
                                                                size=""
                                                                sx={{ width: '100px', border: 'none', '& :focus': { background: 'unset' } }}
                                                                onBlur={(e) => editItem !== a.id ? onEmptyClick : onChangeEditItem(e.target.value, a.id)}
                                                            ></TextField>}
                                                            variant="outlined"
                                                            sx={{ color: a.color ? a.color : 'auto', ml: 0, marginRight: 1 }}
                                                            onClick={() => isEdit ? handleClick(a.id) : onEmptyClick}
                                                            onDelete={isEdit ? (e) => handleDelete(a.id) : null}

                                                        />
                                                    </span>
                                                </Tooltip>
                                            )}
                                            {_.includes(addItem, item.id) && AddNewSubTopic(item.data.length, item.id)}
                                            {isEdit &&
                                                <Tooltip title={'Add Topic'}>
                                                    <IconButton color={'secondary'} shape="rounded" onClick={() => onAddItem(uuidv4(), item.id)}>
                                                        <AddCircleIcon sx={{ color: '#ccc' }} /></IconButton>
                                                </Tooltip>
                                            }
                                        </Stack>
                                    </Box>
                                )
                            })}
                            {_.includes(addItem, null) && AddNewSubTopic(data.length, null, true)}

                            <Box>
                                {isEdit &&
                                    <Tooltip title={'Add Category'}>
                                        <IconButton shape="rounded" color={'secondary'} sx={{ mt: 3 }} size='large' onClick={() => onAddItem(uuidv4(), null)}><AddCircleIcon sx={{ color: '#ccc' }} onClick={() => onAddItem(uuidv4(), null)} /></IconButton>
                                    </Tooltip>
                                }
                            </Box>

                        </Box>
                    </Box>
                }
            </Box >

        </Grid >

    )
}

export default Topics
